import React, {useState} from 'react';
import SqftStore from "../canvas/store/sqftStore";

const LightIntensitySlider = ({ initialValue, minValue, maxValue }) => {
  const [intensity, setIntensity] = useState(initialValue);

  // Функция обновления интенсивности и вызов внешнего метода
  const handleChange = (e) => {
    const newIntensity = Number(e.target.value);
    console.log("Intensity", newIntensity);
    setIntensity(newIntensity);
    SqftStore.viewGL.updateLightIntensity(newIntensity);
  };

  return (
    <input
      type="range"
      min={minValue}
      max={maxValue}
      value={intensity}
      onChange={handleChange}
      className="intensitySlider"
    />
  );
};

export default LightIntensitySlider;
